import React from 'react';
import useDocumentTitle from './useDocumentTitle'
import NavbarEmpty from './emptyNavbar';
import DesignSidebar from './designSidebar';


export default function BeltTool() {
  useDocumentTitle("Belt Tool | FRC101 by the Spartabots")
  return (
    <div>
      <NavbarEmpty />
      <div class="flex max-w-[100rem] mx-auto my-5 bg-gradient-to-r from-frcyellow to-frcpurple rounded-[2rem] items-center">
        <p class="font-scoutcond font-black italic text-white opacity-30 text-[30rem] ml-10 leading-none">101</p>
        <h class="z-20 absolute font-scoutcond font-black italic text-frcblue text-[10rem] ml-40 leading-none">DESIGN TOOL</h>
        <p class="absolute ml-[9.4rem] mt-44 font-scoutcond font-black italic text-white text-[4rem] leading-none">RPM AND SPEED CALCULATOR</p>
      </div>
      <div class="flex flex-row max-w-[100rem] mx-auto mb-5" id="tool">
        <div class="hidden md:flex basis-80 bg-gray-300 rounded-l-[2rem]">
          <DesignSidebar />
        </div>
        <div class="basis-full bg-gray-50 rounded-r-[2rem]">
          <div class="mx-10 my-10">
            <h class="font-scoutcond font-black italic text-[5rem] leading-none">BELT CALCULATOR</h>
            <p class="font-productsans font-bold text-3xl text-gray-500 mb-5">For all kinds of 3mm & 5mm belts</p>
            <Calculator />
          </div>
        </div>
      </div>
    </div>
  )
}

function round(num, places) {
  var multiplier = Math.pow(10, places);
  return Math.round(num * multiplier) / multiplier;
}

function outputValue(value) {
  const input = parseFloat(value);
  if (Number.isNaN(input)) {
    return '';
  }
  return (value).toString();
}

const scaleNames = {
  pulley1: "Pulley #1 Teeth:",
  pulley2: "Pulley #2 Teeth:",
  centerDist: "Center Distance (in):",
}

class GenericInput extends React.Component {
  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(e) {
    this.props.onChange(e.target.value);
  }

  render() {
    const value = this.props.value;
    const scale = this.props.scale;
    return (
      <fieldset>
        <legend class="font-productsans font-bold">{scaleNames[scale]}</legend>
        <input class="font-productsans font-bold bg-gray-500 text-white px-2 rounded-md" value={value}
          onChange={this.handleChange} />
      </fieldset>
    );
  }
}

class Dropdown extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    this.props.onChange(e.target.value);
  }

  render() {
    return (
      <div class="mb-2">
        <p class="font-productsans font-bold text-xl">Belt Pitch:</p>
        <select value={this.props.pitch} onChange={this.handleChange} class="bg-gray-500 rounded-md font-productsans font-bold text-lg text-white p-1">
          <option name="3mm">3mm</option>
          <option name="5mm">5mm</option>
        </select>
      </div>
    );
  }
}

function roundToFive(num) {
  if (num % 5 === 0) {
    return num
  }
  else if (num % 10 < 3) {
    return ((num - (num % 10)))
  }
  else if (num % 10 === 3 || num % 10 === 4 || num % 10 === 6 || num % 10 === 7) {
    return ((num - (num % 10)) + 5)
  }
  else if (num % 10 > 7) {
    return ((num - (num % 10)) + 10)
  }
}

class Calculator extends React.Component {
  constructor(props) {
    super(props);
    this.handlePulleyOneChange = this.handlePulleyOneChange.bind(this);
    this.handlePulleyTwoChange = this.handlePulleyTwoChange.bind(this);
    this.handleCenterChange = this.handleCenterChange.bind(this);
    this.handlePitchChange = this.handlePitchChange.bind(this);
    this.handlePitchValue = this.handlePitchValue.bind(this);

    this.pitchName = "3mm"
    this.state = { 
     pull1: "0", pull2: "0", center: "0", pitchName: "3mm", pitch: "3"};

  }

  handlePulleyOneChange(pull1) {
    this.setState({ pull1 })
  }
  handlePulleyTwoChange(pull2) {
    this.setState({ pull2 })
  }
  handleCenterChange(center) {
    this.setState({ center })
  }
  handlePitchChange(pitchName) {
    this.setState({ pitchName }, () => this.runPitchCheck())
  }
  handlePitchValue(pitch) {
    this.setState({ pitch })
  }

  runPitchCheck() {
    if (this.pitchName === "3mm") {
      this.handlePitchValue(3)
    }
    if (this.pitchName === "5mm") {
      this.handlePitchValue(5)
    }
  }

  render() {
    const pitchSelector = <Dropdown
    pitchName={this.state.pitchName}
      onChange={this.handlePitchChange} />
    this.pitchName = pitchSelector.props.pitchName
    
    const c_cInTeeth = outputValue(round((this.state.center * (25.4/this.state.pitch)), 3))
    const beltLengthInTeeth = outputValue(round(((this.state.pull1/2) + (this.state.pull2/2) + (c_cInTeeth*2)), 0))
    const approxBeltLength = outputValue(roundToFive(round(((this.state.pull1/2) + (this.state.pull2/2) + (c_cInTeeth*2)), 0)))
    const approxC_CInTeeth = outputValue((approxBeltLength - ((this.state.pull1/2) + (this.state.pull2/2))) / 2)
    const approxCenterDistance = outputValue(round(((approxBeltLength - ((this.state.pull1/2) + (this.state.pull2/2))) / 2 * 3 / 25.4), 3))

    return (
      <div>
        {pitchSelector}
        <div class="flex">
          <div>
            <GenericInput
              value={this.state.pull1}
              scale="pulley1"
              onChange={this.handlePulleyOneChange} />
            <GenericInput
              value={this.state.pull2}
              scale="pulley2"
              onChange={this.handlePulleyTwoChange} />
            <GenericInput
              value={this.state.center}
              scale="centerDist"
              onChange={this.handleCenterChange} />
          </div>
        </div>
        <div class="flex w-full mt-10">
          <div>
            <div class="font-productsans font-bold text-xl flex w-[24rem] px-2 py-2 mt-2 bg-gradient-to-r from-frcyellow to-frcpurple rounded-[0.5rem] justify-between"><p>Belt C-C:</p><p class="text-white">{c_cInTeeth} teeth ({this.state.pitchName})</p></div>
            <div class="font-productsans font-bold text-xl flex w-[24rem] px-2 py-2 mt-3 bg-gradient-to-r from-frcyellow to-frcpurple rounded-[0.5rem] justify-between"><p>Belt Length:</p><p class="text-white">{beltLengthInTeeth} teeth ({this.state.pitchName})</p></div>
          </div>
          <div class="mx-5">
            <div class="font-productsans font-bold text-xl flex w-[36rem] px-2 py-2 mt-2 bg-gradient-to-r from-frcyellow to-frcpurple rounded-[0.5rem] justify-between">
              <p>Approximate Center Distance:</p>
              <p class="text-white">{approxCenterDistance} in <span class="text-black">&nbsp;&nbsp;or&nbsp;&nbsp;</span> {approxC_CInTeeth} teeth</p>
            </div>
            <div class="font-productsans font-bold text-xl flex w-[36rem] px-2 py-2 mt-3 bg-gradient-to-r from-frcyellow to-frcpurple rounded-[0.5rem] justify-between">
              <p>Approximate Belt Length:</p>
              <p class="text-white">{approxBeltLength} teeth ({this.state.pitchName})</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}